import { useId, type ReactNode } from 'react';
import { PopupHeader } from '../molecules';
import { Popup } from '../organisms';

interface PopupTemplateProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: ReactNode;
  /** Pinned under the scrollable body, e.g. FormActions or a confirm/cancel row. */
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  closeOnOverlayClick?: boolean;
  children: ReactNode;
}

/** Standard popup layout - header with title/close, scrollable body, optional footer. The shared entry point any module opens a popup through. */
export function PopupTemplate({ open, onClose, title, description, footer, size, closeOnOverlayClick, children }: PopupTemplateProps) {
  const titleId = useId();
  return (
    <Popup open={open} onClose={onClose} size={size} closeOnOverlayClick={closeOnOverlayClick} labelledBy={titleId}>
      <PopupHeader titleId={titleId} title={title} description={description} onClose={onClose} />
      <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
      {footer && <div className="border-t border-line px-5 py-4">{footer}</div>}
    </Popup>
  );
}
